import type { ComponentType, FC } from "react";
import { memo } from "react";

import { translate } from "app/filters/i18nFilter";

import BrandedTrafficTable from "./components/BrandedTrafficTable/BrandedTrafficTable";
import OrganicPaidTable from "./components/OrganicPaidTable/OrganicPaidTable";
import RankPositionTable from "./components/RankPositionTable/RankPositionTable";
import SearchTrafficTable from "./components/SearchTrafficTable/SearchTrafficTable";
import TopNonBrandedKeywordsTable from "./components/TopNonBrandedKeywordsTable/TopNonBrandedKeywordsTable";
import { getPpcHeight } from "./helpers/helpers";
import SearchOverviewPpcSpend from "./search-overview-ppc-spend/SearchOverviewPpcSpend";
import { SearchOverviewGraphConnected } from "./SearchOverviewGraph/SearchOverviewGraph";
import { Container, Row, Title, WidgetsOverviewWrapper, Widget, CompareOverviewWrapper } from "./styledComponents";
import { SearchOverviewTexts } from "./texts";

interface OverviewWidgetProps {
    Component: ComponentType;
    componentProps?: Record<string, unknown>;
}

const WidgetWrapper: FC<OverviewWidgetProps> = ({ Component, componentProps = {} }) => (
    <Widget>
        <Component {...componentProps} />
    </Widget>
);

const SearchOverviewCompare: FC = () => {
    const ppcContentHeight = getPpcHeight();

    return (
        <CompareOverviewWrapper>
            <WidgetsOverviewWrapper data-automation="SearchOverviewCompare">
                <Title>{translate(SearchOverviewTexts.overview)}</Title>
                <Container>
                    <Row>
                        <WidgetWrapper Component={SearchTrafficTable} />
                        <WidgetWrapper Component={BrandedTrafficTable} />
                    </Row>
                    <Row>
                        <WidgetWrapper Component={OrganicPaidTable} />
                    </Row>
                    <Row>
                        <WidgetWrapper
                            Component={RankPositionTable}
                            componentProps={{ contentHeight: ppcContentHeight }}
                        />
                        <WidgetWrapper
                            Component={SearchOverviewPpcSpend}
                            componentProps={{ contentHeight: ppcContentHeight }}
                        />
                    </Row>
                </Container>
            </WidgetsOverviewWrapper>
            <SearchOverviewGraphConnected />
            <TopNonBrandedKeywordsTable />
        </CompareOverviewWrapper>
    );
};

export default memo(SearchOverviewCompare);
